import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Form, Dropdown } from 'semantic-ui-react';
import { debounce } from 'lodash';
import searchUser from 'redux/actions/user/searchUser';
import './index.scss';

const UserSearch = ({
  name,
  handleChange,
  error,
  showIcon,
  allowAdditions,
}) => {
  const { items, loading } = useSelector(
    ({ user: { searchUser } }) => searchUser,
  );

  const [user, setUser] = useState();
  const [value, setValue] = useState('');
  const [addedOptions, setAdddedOptions] = useState([]);

  const dispatch = useDispatch();

  const debouncedSearch = useRef(
    debounce(query => {
      searchUser(query)(dispatch);
    }, 400),
  ).current;

  const handleSearchChange = (e, { searchQuery }) => {
    setValue(searchQuery);
    debouncedSearch(searchQuery);
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      debouncedSearch.flush();
      searchUser(value)(dispatch);
    }
  };

  const itemOptions = (items || []).map(
    ({
      id,
      first_name: firstName,
      last_name: lastName,
      phone_number: phoneNumber,
    }) => ({
      text: `${firstName}  ${lastName} ${phoneNumber}`,
      value: phoneNumber,
      key: id,
    }),
  );

  const [selectedOption, setSelectedOption] = useState();

  const options = [...itemOptions, ...addedOptions];

  const handleAddition = (e, { name, value }) => {
    setAdddedOptions([{ text: value, value }]);
    handleChange(e, { name, value, addition: true, user });
  };

  const onChange = (e, { name, value }) => {
    setSelectedOption(value.replace(/[a-zA-Z]/g, ''));

    const user = items.find(
      item => Number(item.phone_number) === Number(value),
    );
    handleChange(e, { name, value, user });
    setUser(user);
  };

  return (
    <div className={showIcon ? 'user-search' : undefined}>
      <Form.Field
        required
        control={Dropdown}
        search
        selection
        error={error}
        loading={loading}
        onSearchChange={handleSearchChange}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        onAddItem={handleAddition}
        options={options}
        allowAdditions={allowAdditions}
        type="text"
        label="User"
        name={name}
        value={selectedOption}
        placeholder="Search..."
        icon={showIcon ? 'search' : 'dropdown'}
      />
    </div>
  );
};

UserSearch.defaultProps = {
  name: 'phone_number',
  showIcon: false,
  allowAdditions: true,
};

UserSearch.propTypes = {
  handleChange: PropTypes.func.isRequired,
  error: PropTypes.bool.isRequired,
  name: PropTypes.string,
  showIcon: PropTypes.bool,
  allowAdditions: PropTypes.bool,
};

export default UserSearch;
